export const createEvent = (event) => {
    return (dispatch, getState, {getFirebase, getFirestore}) => {
        const user = getFirebase().auth().currentUser;
        const firestore = getFirestore();
        
        // Convert date string to Date object
        event.date = new Date(event.date)

        // Convert location to coordinates
        var request = new XMLHttpRequest()
        var url = "https://cors-anywhere.herokuapp.com/https://hacksc2020-a069e.appspot.com/coordinates?address=" + event.location;
        request.open('GET', url, true)

        request.onload = function() {
            // Parse JSON
            var data = JSON.parse(this.response);
            if (data.status === "FAIL") {
                dispatch({
                    type: 'CREATE_ERROR',
                    data: "Could not convert address to coordinates."
                })
            }
            
            // Set event coordinates and submit to Firebase
            event.lat = data.lat;
            event.lon = data.lon;
            event.open = true;
            event.owner = user.uid;
            event.timeStamp = new Date()
            firestore.collection('events').add(event).then(ref => {
                dispatch({type: 'CREATE_SUCCESS', data: ref.id})
            }).catch(err => {
                dispatch({type: 'CREATE_ERROR', data: err.message})
            })
        }
        request.send()
    }
}

export const registerEvent = (info) => {
    return (dispatch, getState, {getFirebase, getFirestore}) => {
        const user = getFirebase().auth().currentUser;
        const firestore = getFirestore();

        firestore.collection('users').doc(user.uid).get().then(user => {
            info.firstName = user.data().firstName;
            info.lastName = user.data().lastName;

            // Convert location to coordinates
            var request = new XMLHttpRequest()
            var url = "https://cors-anywhere.herokuapp.com/https://hacksc2020-a069e.appspot.com/coordinates?address=" + info.location;
            request.open('GET', url, true)

            request.onload = function() {
                // Parse JSON
                var data = JSON.parse(this.response);
                if (data.status === "FAIL") {
                    dispatch({
                        type: 'CREATE_ERROR',
                        data: "Could not convert address to coordinates."
                    })
                }
                
                // Set event coordinates and submit to Firebase
                info.lat = data.lat;
                info.lon = data.lon;
                info.timeStamp = new Date()
                info.user = user.id;
                firestore.collection('participants').add(info).then(ref => {
                    dispatch({type: 'CREATE_SUCCESS', data: ref.id})
                }).catch(err => {
                    dispatch({type: 'CREATE_ERROR', data: err.message})
                })
            }
            request.send()
        })
    }
}

export const generateRoute = (event) => {
    return (dispatch, getState, {getFirebase, getFirestore}) => {
        const user = getFirebase().auth().currentUser;
        const firestore = getFirestore();

        // Setup coordinate strings
        var lat = 'lat=' + event.lat.toString() + ','
        var lon = 'lon=' + event.lon.toString() + ','
        var driverLat = ''
        var driverLon = ''
        var riderLat = ''
        var riderLon = ''

        // Get all users who are involved in the event
        firestore.collection('participants').where('eventID', '==', event.id)
            .get().then(guests => {
                var numDrivers = 0;
                var guestDict = {}
                guests.forEach(guest => {
                    const data = guest.data()
                    guestDict[(data.lat + data.lon).toString()] = data;
                    guestDict[(data.lat + data.lon).toString()].id = guest.id;
                    if (data.role == 'Rider') {
                        riderLat += data.lat.toString() + ','
                        riderLon += data.lon.toString() + ','
                    } else {    // Driver
                        driverLat += data.lat.toString() + ','
                        driverLon += data.lon.toString() + ','
                        numDrivers += 1;
                    }
                })

                // Generate URL arguments for the API
                lat += driverLat + riderLat;
                lon += driverLon + riderLon;
                const url = "https://cors-anywhere.herokuapp.com/" + 
                    "https://hacksc2020-a069e.appspot.com/route?num_drivers=" +
                    numDrivers.toString() + "&" + lat.substring(0, lat.length - 1) +
                    "&" + lon.substring(0, lon.length - 1)
                
                // Request and process route from API
                var request = new XMLHttpRequest()
                request.open('GET', url, true)
                request.onload = function() {
                    // Parse JSON
                    var data = JSON.parse(this.response);
                    if (data.status === "FAIL") {
                        dispatch({
                            type: 'CREATE_ERROR',
                            data: "Could not convert address to coordinates."
                        })
                    }
                    
                    // Save route data to the users
                    var batch = firestore.batch();
                    var ref = firestore.collection('events').doc(event.id);
                    batch.update(ref, {'open': false})
                    const colors = ['green', 'blue', 'orange', 'purple', 'yellow'];
                    var routeNum = 0;
                    for (var route of data.routes) {
                        var first = route[0];
                        var driverDict = guestDict[(first.lat + first.lon).toString()];
                        var driver = driverDict.firstName + " " + driverDict.lastName;
                        var color = colors[routeNum];
                        for (var i = 0; i < route.length - 1; i++) {
                            var coord = route[i];
                            var g = guestDict[(coord.lat + coord.lon).toString()];
                            var ref = firestore.collection("participants").doc(g.id);
                            batch.update(ref, {
                                'driver': driver,
                                'color': color,
                                'route': routeNum,
                                'stop': i
                            });

                        }
                        routeNum += 1;
                    }
                    batch.commit()
                }
                request.send()
            }
            )
    }
}